import { Box, Divider, Typography } from "@mui/material";
import Flexbetween from "components/FlexBetween";
import { useEffect, useMemo } from "react";
import { fieldLabels, formulaireSasu1 } from "constants/form.constants";
import apiService from "services/apiService";

import { useParams } from "react-router-dom";
import { useState } from "react";
import { getPackFromPriceId } from "scenes/stripe/checkoutSuccess";

const StatusPage = () => {
  const statusRef = useParams().ref;
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchStatusData = async () => {
      try {
        const { data, error } = await apiService.fetchData(
          `/users/${statusRef}`
        );
        if (error) {
          console.error(error);
        }
        if (data) {
          setData(data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    if (statusRef) {
      fetchStatusData();
    }
  }, [statusRef]);

  const packLabel = useMemo(() => {
    if (!data) {
      return "N/A";
    }
    const pack = getPackFromPriceId(data.price_id);
    switch (pack) {
      case "starter":
        return "Starter";
      case "starter_pro":
        return "Starter Pro";
      case "premium":
        return "Premium";
      default:
        return "N/A";
    }
  }, [data]);

  return (
    <Box sx={{ height: "100%", overflowY: "scroll" }}>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          backgroundColor: "#FFF",
          zIndex: 999,
          p: 2,
          textAlign: "center",
        }}
      >
        <Typography variant="h1">Réference : {statusRef}</Typography>
        <Typography variant="h1">Pack : {packLabel}</Typography>
      </Box>
      {data && (
        <Flexbetween
          sx={{
            justifyContent: "center",
            gap: "4rem",
            alignItems: "flex-start",
            minHeight: "calc(100% - 120px)",
          }}
        >
          <Box
            sx={{
              padding: "20px",
              mt: "50px",
            }}
          >
            <Flexbetween
              sx={{ flexDirection: "column", alignItems: "flex-start", gap: 4 }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "0px",
                }}
              >
                {formulaireSasu1.map((section) => {
                  if (["recapitulatif", "stripe"].includes(section.form.type)) {
                    return null;
                  }
                  return (
                    <Box sx={{ mb: "30px", width: "100%" }}>
                      <Typography
                        key={section.label}
                        variant="h2"
                        fontWeight="bold"
                      >
                        {section.label}
                      </Typography>
                      {section.form?.questions?.map((question) => {
                        const value = data.data[question.key];
                        if (!value) {
                          return null;
                        }
                        return (
                          <>
                            <Flexbetween
                              sx={{
                                gap: "5px",
                              }}
                            >
                              <Typography>
                                {fieldLabels[question.key]}:
                              </Typography>
                              <Typography variant="h6">{value}</Typography>
                            </Flexbetween>
                            <Divider />
                          </>
                        );
                      })}
                    </Box>
                  );
                })}
              </Box>
            </Flexbetween>
          </Box>
        </Flexbetween>
      )}
    </Box>
  );
};

export default StatusPage;
